<template>
  <mavon-editor v-model="markData" :subfield="false" :boxShadow="false" defaultOpen="preview" :style="customStyle"
                :toolbarsFlag="false" id="article-main-content-mavon"/>
</template>

<script>

export default {
  name: "MarkdMain",
  props: {
    markData: String,
    customStyle: {}
  },
}
</script>

<style scoped>

#article-main-content-mavon {
  z-index: 0;
  text-align: left;
  border: 0;
  border-radius: 0 !important;
}
</style>